import { Field, reduxForm } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import InputField from 'client/features/form/components/InputField.jsx'
import REGEXP from 'constant/REGEXP'

const validate = values => {
    const errors = {}
    if (!values.password || !values.password[5])
        errors.password = 'Min. 6 caractères'
    else if (values.password !== values.verification)
        errors.verification = 'Incorrect'
    return errors
}

class UpdatePasswordForm extends Component {
    render() {
        const { handleSubmit, pristine, submitting, error } = this.props
        return (
            <form onSubmit={ handleSubmit } className='form-horizontal m-t-10'>
                <Field name='password' component={ InputField } type='password' placeholder='Mot de passe...'/>
                <Field name='verification' component={ InputField } type='password' placeholder='Verification...'/>
                <div className='form-group text-center m-t-30'>
                    <div className='col-xs-12'>
                        <button className='btn btn-custom btn-bordred btn-block waves-effect waves-light text-uppercase' type='submit' disabled={ pristine || submitting }>Enregistrer</button>
                    </div>
                </div>
                {
                    error ? <p className='error' id='login-error'>{ error }</p> : null
                }
            </form>
        )
    }
}

UpdatePasswordForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
} 

export default UpdatePasswordForm = reduxForm({
    form: 'UpdatePassword',
    validate
})(UpdatePasswordForm)


// WEBPACK FOOTER //
// ./src/client/features/session/components/UpdatePasswordForm.jsx